/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import trackAction from 'utils/tracking';
import { ACTION_NODE_LINK } from 'constants/Action';
import GLOBAL_MEDIA_QUERIES from 'constants/Screen';

import Cta from 'components/Core/Cta';

import { CtaBlockElem } from './CtaBlock.styles';

const CtaBlock = (props) => {
  const { id, title, body: contentText, linkTitle, link, fullWidth } = props;

  // A bit quirky as backend is passing link as an array with one item in it.
  const ctaLink = link[0];
  const { type: linkType } = ctaLink;

  let urlHref;

  const isExternalUrl = linkType === 'URLBlock';

  if (isExternalUrl) {
    const { url } = ctaLink;
    urlHref = url;
  } else if (ctaLink.page) {
    const {
      page: { url },
    } = ctaLink;
    urlHref = url;
  } else {
    urlHref = '/pagina-niet-gevonden';
  }

  return (
    <div className="container mx-auto px-4">
      <div className="w-full u-block-margins text-basic-700" key={`ctaBlock-${id}`}>
        <CtaBlockElem fullWidth={fullWidth}>
          <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ lg: true }}>
            {(matches) => {
              if (matches.lg || matches.xl) {
                return <h2 className="my-4">{title}</h2>;
              }
              return <h3 className="my-4">{title}</h3>;
            }}
          </Media>

          <p className="text-base leading-6 my-8">{contentText}</p>
          {isExternalUrl && (
            <Cta
              className="w-full md:w-auto"
              node={ACTION_NODE_LINK}
              external
              href={urlHref}
              showIcon={false}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAction('CTA', linkTitle, 'click')}
              onKeyPress={() => trackAction('CTA', linkTitle, 'click')}
            >
              {linkTitle}
            </Cta>
          )}
          {!isExternalUrl && (
            <Cta
              className="w-full md:w-auto"
              node={ACTION_NODE_LINK}
              href="/[...slug]"
              as={urlHref}
              showIcon={false}
              onClick={() => trackAction('CTA', linkTitle, 'click')}
              onKeyPress={() => trackAction('CTA', linkTitle, 'click')}
            >
              {linkTitle}
            </Cta>
          )}
        </CtaBlockElem>
      </div>
    </div>
  );
};

CtaBlock.defaultProps = {
  fullWidth: false,
};

CtaBlock.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  linkTitle: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  link: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        page: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      }),
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ]),
  ).isRequired,
};

export default CtaBlock;
